import React from 'react';

import { Tab, TabHeader, TabsContainer, TabText } from './dpos-rewards-tabs.styles';
import { DPOSRewardsTabsProps } from './dpos-utils';

export const DPOSRewardsTabs: React.FC<DPOSRewardsTabsProps> = ({ selectedTab, onTabChange, children, tabOptions }) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>): void => {
    const currentIndex = tabOptions.findIndex((tab) => tab.value === selectedTab);
    const isNotLastTab = currentIndex !== tabOptions.length - 1;
    if (isNotLastTab && e.key === 'Tab') {
      onTabChange(tabOptions[currentIndex + 1].value);
    }
  };

  const firstTabValue = tabOptions.length > 0 ? tabOptions[0].value : '';
  const isFirstTabSelected = selectedTab === firstTabValue;

  return (
    <TabsContainer data-testid='dpos-rewards-tabs'>
      <TabHeader firstTabSelected={isFirstTabSelected} role='tablist'>
        {tabOptions.map(({ value, label, display }) => {
          const selected = selectedTab === value;
          return (
            <Tab
              key={value}
              role='tab'
              id={`tab-${value}`}
              aria-controls={`tabpanel-${value}`}
              aria-selected={selected}
              tabIndex={selected ? 0 : -1}
              selected={selected}
              onClick={() => onTabChange(value)}
              onKeyDown={handleKeyDown}
              display={display}
            >
              <TabText size='medium' weight='semi' selected={selectedTab === value}>
                {label}
              </TabText>
            </Tab>
          );
        })}
      </TabHeader>
      {children}
    </TabsContainer>
  );
};
